import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
const resources = {
  en: {
    translation: {
      // Header
      "nav.services": "Services",
      "nav.book": "Book Appointment",
      "nav.projects": "Projects",
      "nav.testimonials": "Testimonials",
      "nav.sustainability": "Sustainability",
      "nav.contact": "Contact",
      "nav.reschedule": "Reschedule",
      
      // Hero
      "hero.title1": "Premium Renovations.",
      "hero.title2": "Unbeatable Prices.",
      "hero.subtitle": "We work smarter and source materials directly — that's how we deliver top-quality renovations in Amsterdam for less than anyone else. No middlemen. No shortcuts. Just honest pricing.",
      "hero.cta1": "Get Free Quote",
      "hero.cta2": "Our Services",
      "hero.stat1": "Projects Completed",
      "hero.stat2": "Years Experience",
      "hero.stat3": "Satisfaction Rate",
      "hero.badge1": "Efficient Workflow",
      "hero.badge2": "Direct Sourcing",
      "hero.badge3": "Honest Pricing",
      
      // Services
      "services.title": "Our Services",
      "services.subtitle": "Comprehensive home improvement solutions tailored to your needs",
      
      // Service Items
      "service.houseReno.title": "House Renovation",
      "service.houseReno.desc": "Complete home transformations from concept to completion. We handle everything to create your dream space.",
      "service.houseReno.feature1": "Full home renovations",
      "service.houseReno.feature2": "Kitchen remodeling",
      "service.houseReno.feature3": "Living space upgrades",
      "service.houseReno.feature4": "Custom design solutions",
      
      "service.bathroom.title": "Bathroom Renovation",
      "service.bathroom.desc": "Transform your bathroom into a modern sanctuary with our expert renovation services.",
      "service.bathroom.feature1": "Modern fixtures",
      "service.bathroom.feature2": "Tile installation",
      "service.bathroom.feature3": "Waterproofing",
      "service.bathroom.feature4": "Complete redesign",
      
      "service.painting.title": "Painting",
      "service.painting.desc": "Professional interior and exterior painting services that bring fresh life to your property.",
      "service.painting.feature1": "Interior painting",
      "service.painting.feature2": "Exterior painting",
      "service.painting.feature3": "Color consultation",
      "service.painting.feature4": "Premium finishes",
      
      "service.plumbing.title": "Plumbing",
      "service.plumbing.desc": "Expert plumbing services for installations, repairs, and maintenance. Fast and reliable.",
      "service.plumbing.feature1": "Emergency repairs",
      "service.plumbing.feature2": "Pipe installation",
      "service.plumbing.feature3": "Leak detection",
      "service.plumbing.feature4": "Fixture replacement",
      
      "service.plastering.title": "Plastering",
      "service.plastering.desc": "High-quality plastering for smooth, perfect walls and ceilings. Professional finish guaranteed.",
      "service.plastering.feature1": "Wall plastering",
      "service.plastering.feature2": "Ceiling work",
      "service.plastering.feature3": "Repair work",
      "service.plastering.feature4": "Smooth finishes",
      
      // How It Works
      "process.title": "How It Works",
      "process.subtitle": "Our simple 4-step process to transform your space",
      "process.step1.number": "01",
      "process.step1.title": "Contact Us",
      "process.step1.desc": "Reach out to us by phone, email, or WhatsApp. We're ready to hear about your project.",
      "process.step2.number": "02",
      "process.step2.title": "Get Your Quote",
      "process.step2.desc": "Based on your information, we create a detailed plan and quote. You'll receive it within 12 hours on the same day.",
      "process.step3.number": "03",
      "process.step3.title": "We Bring Your Vision to Life",
      "process.step3.desc": "Our experienced professionals execute your project with precision. Sit back and relax while we handle everything.",
      "process.step4.number": "04",
      "process.step4.title": "Perfect Finishing",
      "process.step4.desc": "We add the finishing touches, ensure perfection, and exceed your expectations.",

      // Why Choose Us
      "why.title": "Why Choose Basic Job?",
      "why.subtitle": "Amsterdam's trusted partner for home renovation and improvement",
      "why.quality": "Quality Guaranteed",
      "why.qualityDesc": "We stand behind our work with comprehensive warranties and quality assurance.",
      "why.experience": "15+ Years Experience",
      "why.experienceDesc": "Proven expertise in all aspects of home renovation and improvement.",
      "why.team": "Professional Team",
      "why.teamDesc": "Skilled craftsmen who treat your home with respect and care.",
      "why.ontime": "On-Time Delivery",
      "why.ontimeDesc": "We respect your time and complete projects within agreed timelines.",
      
      // Appointments
      "appointments.title": "Book an Appointment",
      "appointments.subtitle": "Schedule a consultation or site visit at your convenience",
      "appointments.selectDate": "Select Date & Time",
      "appointments.availableSlots": "Available Time Slots",
      "appointments.loading": "Loading slots...",
      "appointments.noSlots": "No available slots for this date",
      "appointments.selected": "Selected:",
      "appointments.details": "Your Details",
      "appointments.name": "Full Name",
      "appointments.email": "Email",
      "appointments.phone": "Phone",
      "appointments.service": "Service",
      "appointments.address": "Address",
      "appointments.notes": "Additional Notes",
      "appointments.booking": "Booking...",
      "appointments.book": "Book Appointment",
      
      // Projects
      "projects.title": "Our Recent Projects",
      "projects.subtitle": "See the quality of our work and get inspired for your next project",
      "projects.all": "All",
      
      // Testimonials
      "testimonials.title": "What Our Clients Say",
      "testimonials.subtitle": "Don't just take our word for it - hear from our satisfied customers",
      "testimonials.googleButton": "Read More Reviews on Google",
      
      // Testimonial Items
      "testimonial.1.name": "Garima Cupta",
      "testimonial.1.text": "Basic Job completely transformed our bathroom! The team was professional, clean, and finished on time. Highly recommend!",
      "testimonial.1.service": "Bathroom Renovation",
      
      "testimonial.2.name": "Puneet Kedia",
      "testimonial.2.text": "The Basic Job team recently did renovations in our house and the quality of the work was very good. We are very satisfied with their expertise and attention to detail.",
      "testimonial.2.service": "Attic Renovation",
      "testimonial.2.location": "Utrecht",
      
      "testimonial.3.name": "Niharika Sinha",
      "testimonial.3.text": "Fast, reliable, and affordable plumbing service. They fixed our issue quickly and explained everything clearly. Will definitely use again!",
      "testimonial.3.service": "Plumbing",
      "testimonial.3.location": "Uithoorn",
      
      "testimonial.4.name": "Tom Boudewijn",
      "testimonial.4.text": "The painting job on our apartment was flawless. Clean work, professional team, and the color consultation was really helpful!",
      "testimonial.4.service": "Painting",
      
      // Quote
      "quote.title": "Get Your Free Quote",
      "quote.subtitle": "Tell us about your project and we'll get back to you within 24 hours",
      "quote.message": "Project Details",
      "quote.sending": "Sending...",
      "quote.send": "Request Free Quote",
      
      // Reschedule
      "reschedule.title": "Reschedule Appointment",
      "reschedule.subtitle": "Enter your appointment ID to reschedule or cancel",
      "reschedule.appointmentId": "Appointment ID",
      "reschedule.search": "Search",
      "reschedule.searching": "Searching...",
      "reschedule.current": "Current Appointment Details",
      "reschedule.customerName": "Customer Name",
      "reschedule.currentDate": "Current Date",
      "reschedule.currentTime": "Current Time",
      "reschedule.status": "Status",
      "reschedule.newDateTime": "Select New Date & Time",
      "reschedule.actions": "Actions",
      "reschedule.newAppointment": "New appointment:",
      "reschedule.confirm": "Confirm Reschedule",
      "reschedule.rescheduling": "Rescheduling...",
      "reschedule.cancel": "Cancel Appointment",
      "reschedule.help": "Need help? Call us at",
      "reschedule.helpText": "Your appointment ID was sent to your email when you booked. Can't find it? Contact us at",
      
      // Footer
      "footer.about": "Your trusted partner for professional home renovation and improvement services in Amsterdam.",
      "footer.quickLinks": "Quick Links",
      "footer.ourServices": "Our Services",
      "footer.contactUs": "Contact Us",
      "footer.rights": "All rights reserved.",
      
      // Common
      "common.required": "*"
    }
  },
  nl: {
    translation: {
      // Header
      "nav.services": "Diensten",
      "nav.book": "Afspraak Maken",
      "nav.projects": "Projecten",
      "nav.testimonials": "Referenties",
      "nav.sustainability": "Duurzaamheid",
      "nav.contact": "Contact",
      "nav.reschedule": "Verzetten",
      
      // Hero
      "hero.title1": "Topkwaliteit Renovaties.",
      "hero.title2": "Onverslaanbare Prijzen.",
      "hero.subtitle": "We werken slimmer en kopen materialen rechtstreeks in — zo leveren we topkwaliteit renovaties in Amsterdam voor minder dan welke andere aanbieder ook. Geen tussenpersonen. Geen shortcuts. Gewoon eerlijke prijzen.",
      "hero.badge1": "Efficiënt Werken",
      "hero.badge2": "Directe Inkoop",
      "hero.badge3": "Eerlijke Prijzen",
      "hero.cta1": "Gratis Offerte",
      "hero.cta2": "Onze Diensten",
      "hero.stat1": "Projecten Voltooid",
      "hero.stat2": "Jaar Ervaring",
      "hero.stat3": "Tevredenheid",
      
      // Services
      "services.title": "Onze Diensten",
      "services.subtitle": "Uitgebreide woningverbeteringsoplossingen op maat gemaakt voor uw behoeften",
      
      // Service Items
      "service.houseReno.title": "Huisrenovatie",
      "service.houseReno.desc": "Complete woningtransformaties van concept tot voltooiing. Wij regelen alles om uw droomruimte te creëren.",
      "service.houseReno.feature1": "Complete woningrenovaties",
      "service.houseReno.feature2": "Keukenverbouwing",
      "service.houseReno.feature3": "Woonruimte upgrades",
      "service.houseReno.feature4": "Maatwerk ontwerpoplossingen",
      
      "service.bathroom.title": "Badkamerrenovatie",
      "service.bathroom.desc": "Transformeer uw badkamer in een modern toevluchtsoord met onze deskundige renovatiediensten.",
      "service.bathroom.feature1": "Moderne armaturen",
      "service.bathroom.feature2": "Tegelinstallatie",
      "service.bathroom.feature3": "Waterdichting",
      "service.bathroom.feature4": "Compleet herontwerp",
      
      "service.painting.title": "Schilderwerk",
      "service.painting.desc": "Professionele binnen- en buitenschilderservices die uw eigendom nieuw leven inblazen.",
      "service.painting.feature1": "Binnenschilderwerk",
      "service.painting.feature2": "Buitenschilderwerk",
      "service.painting.feature3": "Kleuradvies",
      "service.painting.feature4": "Premium afwerkingen",
      
      "service.plumbing.title": "Loodgieterswerk",
      "service.plumbing.desc": "Deskundige loodgietersservices voor installaties, reparaties en onderhoud. Snel en betrouwbaar.",
      "service.plumbing.feature1": "Noodreparaties",
      "service.plumbing.feature2": "Leidinginstallatie",
      "service.plumbing.feature3": "Lekdetectie",
      "service.plumbing.feature4": "Armatuurvervanging",
      
      "service.plastering.title": "Stucwerk",
      "service.plastering.desc": "Hoogwaardig stucwerk voor gladde, perfecte muren en plafonds. Professionele afwerking gegarandeerd.",
      "service.plastering.feature1": "Muurstucwerk",
      "service.plastering.feature2": "Plafondwerk",
      "service.plastering.feature3": "Reparatiewerk",
      "service.plastering.feature4": "Gladde afwerkingen",
      
      // How It Works
      "process.title": "Hoe Het Werkt",
      "process.subtitle": "Ons eenvoudige 4-stappenproces om uw ruimte te transformeren",
      "process.step1.number": "01",
      "process.step1.title": "Neem Contact Op",
      "process.step1.desc": "Neem contact met ons op via telefoon, e-mail of WhatsApp. We horen graag over uw project.",
      "process.step2.number": "02",
      "process.step2.title": "Ontvang Uw Offerte",
      "process.step2.desc": "Op basis van uw informatie maken we een gedetailleerd plan en offerte. U ontvangt deze binnen 12 uur op dezelfde dag.",
      "process.step3.number": "03",
      "process.step3.title": "We Brengen Uw Visie Tot Leven",
      "process.step3.desc": "Onze ervaren professionals voeren uw project uit met precisie. Leun achterover en ontspan terwijl wij alles afhandelen.",
      "process.step4.number": "04",
      "process.step4.title": "Perfecte Afwerking",
      "process.step4.desc": "We voegen de laatste hand toe, zorgen voor perfectie en overtreffen uw verwachtingen.",

      // Why Choose Us
      "why.title": "Waarom Kiezen voor Basic Job?",
      "why.subtitle": "Amsterdam's vertrouwde partner voor woningrenovatie en verbetering",
      "why.quality": "Kwaliteit Gegarandeerd",
      "why.qualityDesc": "We staan achter ons werk met uitgebreide garanties en kwaliteitsborging.",
      "why.experience": "15+ Jaar Ervaring",
      "why.experienceDesc": "Bewezen expertise in alle aspecten van woningrenovatie en verbetering.",
      "why.team": "Professioneel Team",
      "why.teamDesc": "Bekwame vakmensen die uw huis met respect en zorg behandelen.",
      "why.ontime": "Tijdige Levering",
      "why.ontimeDesc": "We respecteren uw tijd en voltooien projecten binnen afgesproken deadlines.",
      
      // Appointments
      "appointments.title": "Maak een Afspraak",
      "appointments.subtitle": "Plan een consultatie of bezoek ter plaatse op uw gemak",
      "appointments.selectDate": "Selecteer Datum & Tijd",
      "appointments.availableSlots": "Beschikbare Tijdslots",
      "appointments.loading": "Slots laden...",
      "appointments.noSlots": "Geen beschikbare slots voor deze datum",
      "appointments.selected": "Geselecteerd:",
      "appointments.details": "Uw Gegevens",
      "appointments.name": "Volledige Naam",
      "appointments.email": "E-mail",
      "appointments.phone": "Telefoon",
      "appointments.service": "Dienst",
      "appointments.address": "Adres",
      "appointments.notes": "Aanvullende Opmerkingen",
      "appointments.booking": "Boeken...",
      "appointments.book": "Afspraak Boeken",
      
      // Projects
      "projects.title": "Onze Recente Projecten",
      "projects.subtitle": "Zie de kwaliteit van ons werk en laat u inspireren voor uw volgende project",
      "projects.all": "Alles",
      
      // Testimonials
      "testimonials.title": "Wat Onze Klanten Zeggen",
      "testimonials.subtitle": "Neem niet alleen ons woord ervoor - hoor van onze tevreden klanten",
      "testimonials.googleButton": "Lees Meer Reviews op Google",
      
      // Testimonial Items
      "testimonial.1.name": "Garima Cupta",
      "testimonial.1.text": "Basic Job heeft onze badkamer volledig getransformeerd! Het team was professioneel, netjes en klaar op tijd. Zeer aan te bevelen!",
      "testimonial.1.service": "Badkamerrenovatie",
      
      "testimonial.2.name": "Puneet Kedia",
      "testimonial.2.text": "Het Basic Job-team heeft onlangs renovaties in ons huis uitgevoerd en de kwaliteit van het werk was erg goed. We zijn zeer tevreden met hun expertise en aandacht voor detail.",
      "testimonial.2.service": "Zolderrenovatie",
      "testimonial.2.location": "Utrecht",
      
      "testimonial.3.name": "Niharika Sinha",
      "testimonial.3.text": "Snelle, betrouwbare en betaalbare loodgietersdienst. Ze losten ons probleem snel op en legden alles duidelijk uit. Zeker opnieuw gebruiken!",
      "testimonial.3.service": "Loodgieterswerk",
      
      "testimonial.4.name": "Tom Boudewijn",
      "testimonial.4.text": "Het schilderwerk aan ons appartement was vlekkeloos. Netjes werk, professioneel team en het kleuradvies was echt nuttig!",
      "testimonial.4.service": "Schilderwerk",
      
      // Quote
      "quote.title": "Ontvang Uw Gratis Offerte",
      "quote.subtitle": "Vertel ons over uw project en we nemen binnen 24 uur contact met u op",
      "quote.message": "Projectdetails",
      "quote.sending": "Verzenden...",
      "quote.send": "Vraag Gratis Offerte Aan",
      
      // Reschedule
      "reschedule.title": "Afspraak Verzetten",
      "reschedule.subtitle": "Voer uw afspraak-ID in om te verzetten of annuleren",
      "reschedule.appointmentId": "Afspraak ID",
      "reschedule.search": "Zoeken",
      "reschedule.searching": "Zoeken...",
      "reschedule.current": "Huidige Afspraakdetails",
      "reschedule.customerName": "Klantnaam",
      "reschedule.currentDate": "Huidige Datum",
      "reschedule.currentTime": "Huidige Tijd",
      "reschedule.status": "Status",
      "reschedule.newDateTime": "Selecteer Nieuwe Datum & Tijd",
      "reschedule.actions": "Acties",
      "reschedule.newAppointment": "Nieuwe afspraak:",
      "reschedule.confirm": "Bevestig Verzetten",
      "reschedule.rescheduling": "Verzetten...",
      "reschedule.cancel": "Afspraak Annuleren",
      "reschedule.help": "Hulp nodig? Bel ons op",
      "reschedule.helpText": "Uw afspraak-ID is naar uw e-mail gestuurd toen u boekte. Kunt u het niet vinden? Neem contact met ons op via",
      
      // Footer
      "footer.about": "Uw vertrouwde partner voor professionele woningrenovatie en verbeteringsdiensten in Amsterdam.",
      "footer.quickLinks": "Snelle Links",
      "footer.ourServices": "Onze Diensten",
      "footer.contactUs": "Neem Contact Op",
      "footer.rights": "Alle rechten voorbehouden.",
      
      // Common
      "common.required": "*"
    }
  },
  fr: {
    translation: {
      // Header
      "nav.services": "Services",
      "nav.book": "Prendre Rendez-vous",
      "nav.projects": "Projets",
      "nav.testimonials": "Témoignages",
      "nav.sustainability": "Durabilité",
      "nav.contact": "Contact",
      "nav.reschedule": "Reprogrammer",
      
      // Hero
      "hero.title1": "Rénovations Premium.",
      "hero.title2": "Prix Imbattables.",
      "hero.subtitle": "Nous travaillons plus intelligemment et achetons les matériaux directement — c'est ainsi que nous livrons des rénovations de qualité supérieure à Amsterdam pour moins cher que partout ailleurs. Aucun intermédiaire. Aucun raccourci. Juste des prix honnêtes.",
      "hero.badge1": "Travail Efficace",
      "hero.badge2": "Achat Direct",
      "hero.badge3": "Prix Honnêtes",
      "hero.cta1": "Devis Gratuit",
      "hero.cta2": "Nos Services",
      "hero.stat1": "Projets Réalisés",
      "hero.stat2": "Années d'Expérience",
      "hero.stat3": "Taux de Satisfaction",
      
      // Services
      "services.title": "Nos Services",
      "services.subtitle": "Solutions complètes d'amélioration de l'habitat adaptées à vos besoins",
      
      // Service Items
      "service.houseReno.title": "Rénovation de Maison",
      "service.houseReno.desc": "Transformations complètes de la maison du concept à la réalisation. Nous gérons tout pour créer votre espace de rêve.",
      "service.houseReno.feature1": "Rénovations complètes",
      "service.houseReno.feature2": "Remodelage de cuisine",
      "service.houseReno.feature3": "Améliorations d'espace de vie",
      "service.houseReno.feature4": "Solutions de design personnalisées",
      
      "service.bathroom.title": "Rénovation de Salle de Bain",
      "service.bathroom.desc": "Transformez votre salle de bain en un sanctuaire moderne avec nos services de rénovation experts.",
      "service.bathroom.feature1": "Installations modernes",
      "service.bathroom.feature2": "Pose de carrelage",
      "service.bathroom.feature3": "Imperméabilisation",
      "service.bathroom.feature4": "Refonte complète",
      
      "service.painting.title": "Peinture",
      "service.painting.desc": "Services de peinture intérieure et extérieure professionnels qui donnent une nouvelle vie à votre propriété.",
      "service.painting.feature1": "Peinture intérieure",
      "service.painting.feature2": "Peinture extérieure",
      "service.painting.feature3": "Consultation couleur",
      "service.painting.feature4": "Finitions premium",
      
      "service.plumbing.title": "Plomberie",
      "service.plumbing.desc": "Services de plomberie experts pour installations, réparations et maintenance. Rapide et fiable.",
      "service.plumbing.feature1": "Réparations d'urgence",
      "service.plumbing.feature2": "Installation de tuyauterie",
      "service.plumbing.feature3": "Détection de fuites",
      "service.plumbing.feature4": "Remplacement d'appareils",
      
      "service.plastering.title": "Plâtrerie",
      "service.plastering.desc": "Plâtrerie de haute qualité pour des murs et plafonds lisses et parfaits. Finition professionnelle garantie.",
      "service.plastering.feature1": "Plâtrage de murs",
      "service.plastering.feature2": "Travaux de plafond",
      "service.plastering.feature3": "Travaux de réparation",
      "service.plastering.feature4": "Finitions lisses",
      
      // How It Works
      "process.title": "Comment Ça Marche",
      "process.subtitle": "Notre processus simple en 4 étapes pour transformer votre espace",
      "process.step1.number": "01",
      "process.step1.title": "Contactez-nous",
      "process.step1.desc": "Contactez-nous par téléphone, email ou WhatsApp. Nous sommes prêts à entendre parler de votre projet.",
      "process.step2.number": "02",
      "process.step2.title": "Recevez Votre Devis",
      "process.step2.desc": "Sur la base de vos informations, nous créons un plan et un devis détaillés. Vous le recevrez dans les 12 heures le jour même.",
      "process.step3.number": "03",
      "process.step3.title": "Nous Donnons Vie à Votre Vision",
      "process.step3.desc": "Nos professionnels expérimentés exécutent votre projet avec précision. Détendez-vous pendant que nous nous occupons de tout.",
      "process.step4.number": "04",
      "process.step4.title": "Finition Parfaite",
      "process.step4.desc": "Nous ajoutons les touches finales, assurons la perfection et dépassons vos attentes.",

      // Why Choose Us
      "why.title": "Pourquoi Choisir Basic Job?",
      "why.subtitle": "Le partenaire de confiance d'Amsterdam pour la rénovation et l'amélioration de l'habitat",
      "why.quality": "Qualité Garantie",
      "why.qualityDesc": "Nous soutenons notre travail avec des garanties complètes et une assurance qualité.",
      "why.experience": "15+ Années d'Expérience",
      "why.experienceDesc": "Expertise éprouvée dans tous les aspects de la rénovation et de l'amélioration de l'habitat.",
      "why.team": "Équipe Professionnelle",
      "why.teamDesc": "Des artisans qualifiés qui traitent votre maison avec respect et soin.",
      "why.ontime": "Livraison à Temps",
      "why.ontimeDesc": "Nous respectons votre temps et terminons les projets dans les délais convenus.",
      
      // Appointments
      "appointments.title": "Prendre un Rendez-vous",
      "appointments.subtitle": "Planifiez une consultation ou une visite sur site à votre convenance",
      "appointments.selectDate": "Sélectionner Date & Heure",
      "appointments.availableSlots": "Créneaux Disponibles",
      "appointments.loading": "Chargement des créneaux...",
      "appointments.noSlots": "Aucun créneau disponible pour cette date",
      "appointments.selected": "Sélectionné:",
      "appointments.details": "Vos Coordonnées",
      "appointments.name": "Nom Complet",
      "appointments.email": "Email",
      "appointments.phone": "Téléphone",
      "appointments.service": "Service",
      "appointments.address": "Adresse",
      "appointments.notes": "Notes Supplémentaires",
      "appointments.booking": "Réservation...",
      "appointments.book": "Réserver un Rendez-vous",
      
      // Projects
      "projects.title": "Nos Projets Récents",
      "projects.subtitle": "Découvrez la qualité de notre travail et inspirez-vous pour votre prochain projet",
      "projects.all": "Tous",
      
      // Testimonials
      "testimonials.title": "Ce Que Disent Nos Clients",
      "testimonials.subtitle": "Ne nous croyez pas sur parole - écoutez nos clients satisfaits",
      "testimonials.googleButton": "Lire Plus d'Avis sur Google",
      
      // Testimonial Items
      "testimonial.1.name": "Garima Cupta",
      "testimonial.1.text": "Basic Job a complètement transformé notre salle de bain ! L'équipe était professionnelle, propre et a terminé à temps. Hautement recommandé !",
      "testimonial.1.service": "Rénovation de Salle de Bain",
      
      "testimonial.2.name": "Puneet Kedia",
      "testimonial.2.text": "L'équipe Basic Job a récemment effectué des rénovations dans notre maison et la qualité du travail était très bonne. Nous sommes très satisfaits de leur expertise et de leur attention aux détails.",
      "testimonial.2.service": "Rénovation de Grenier",
      "testimonial.2.location": "Utrecht",
      
      "testimonial.3.name": "Niharika Sinha",
      "testimonial.3.text": "Service de plomberie rapide, fiable et abordable. Ils ont résolu notre problème rapidement et ont tout expliqué clairement. Je les utiliserai certainement à nouveau !",
      "testimonial.3.service": "Plomberie",
      "testimonial.3.location": "Uithoorn",
      
      "testimonial.4.name": "Tom Boudewijn",
      "testimonial.4.text": "Le travail de peinture de notre appartement était impeccable. Travail propre, équipe professionnelle et la consultation couleur était vraiment utile !",
      "testimonial.4.service": "Peinture",
      
      // Quote
      "quote.title": "Obtenez Votre Devis Gratuit",
      "quote.subtitle": "Parlez-nous de votre projet et nous vous recontacterons sous 24 heures",
      "quote.message": "Détails du Projet",
      "quote.sending": "Envoi...",
      "quote.send": "Demander un Devis Gratuit",
      
      // Reschedule
      "reschedule.title": "Reprogrammer le Rendez-vous",
      "reschedule.subtitle": "Entrez votre ID de rendez-vous pour reprogrammer ou annuler",
      "reschedule.appointmentId": "ID de Rendez-vous",
      "reschedule.search": "Rechercher",
      "reschedule.searching": "Recherche...",
      "reschedule.current": "Détails du Rendez-vous Actuel",
      "reschedule.customerName": "Nom du Client",
      "reschedule.currentDate": "Date Actuelle",
      "reschedule.currentTime": "Heure Actuelle",
      "reschedule.status": "Statut",
      "reschedule.newDateTime": "Sélectionner Nouvelle Date & Heure",
      "reschedule.actions": "Actions",
      "reschedule.newAppointment": "Nouveau rendez-vous:",
      "reschedule.confirm": "Confirmer la Reprogrammation",
      "reschedule.rescheduling": "Reprogrammation...",
      "reschedule.cancel": "Annuler le Rendez-vous",
      "reschedule.help": "Besoin d'aide? Appelez-nous au",
      "reschedule.helpText": "Votre ID de rendez-vous vous a été envoyé par email lors de votre réservation. Vous ne le trouvez pas? Contactez-nous à",
      
      // Footer
      "footer.about": "Votre partenaire de confiance pour des services professionnels de rénovation et d'amélioration de l'habitat à Amsterdam.",
      "footer.quickLinks": "Liens Rapides",
      "footer.ourServices": "Nos Services",
      "footer.contactUs": "Contactez-nous",
      "footer.rights": "Tous droits réservés.",
      
      // Common
      "common.required": "*"
    }
  },
  es: {
    translation: {
      // Header
      "nav.services": "Servicios",
      "nav.book": "Reservar Cita",
      "nav.projects": "Proyectos",
      "nav.testimonials": "Testimonios",
      "nav.sustainability": "Sostenibilidad",
      "nav.contact": "Contacto",
      "nav.reschedule": "Reprogramar",
      
      // Hero
      "hero.title1": "Renovaciones Premium.",
      "hero.title2": "Precios Inmejorables.",
      "hero.subtitle": "Trabajamos de forma más inteligente y compramos los materiales directamente — así entregamos renovaciones de máxima calidad en Ámsterdam por menos que cualquier otro. Sin intermediarios. Sin atajos. Solo precios honestos.",
      "hero.badge1": "Trabajo Eficiente",
      "hero.badge2": "Compra Directa",
      "hero.badge3": "Precios Honestos",
      "hero.cta1": "Presupuesto Gratis",
      "hero.cta2": "Nuestros Servicios",
      "hero.stat1": "Proyectos Completados",
      "hero.stat2": "Años de Experiencia",
      "hero.stat3": "Tasa de Satisfacción",
      
      // Services
      "services.title": "Nuestros Servicios",
      "services.subtitle": "Soluciones integrales de mejoras para el hogar adaptadas a sus necesidades",
      
      // Service Items
      "service.houseReno.title": "Renovación de Casa",
      "service.houseReno.desc": "Transformaciones completas del hogar desde el concepto hasta la finalización. Manejamos todo para crear su espacio soñado.",
      "service.houseReno.feature1": "Renovaciones completas del hogar",
      "service.houseReno.feature2": "Remodelación de cocina",
      "service.houseReno.feature3": "Mejoras de espacio habitable",
      "service.houseReno.feature4": "Soluciones de diseño personalizadas",
      
      "service.bathroom.title": "Renovación de Baño",
      "service.bathroom.desc": "Transforme su baño en un santuario moderno con nuestros servicios expertos de renovación.",
      "service.bathroom.feature1": "Instalaciones modernas",
      "service.bathroom.feature2": "Instalación de azulejos",
      "service.bathroom.feature3": "Impermeabilización",
      "service.bathroom.feature4": "Rediseño completo",
      
      "service.painting.title": "Pintura",
      "service.painting.desc": "Servicios profesionales de pintura interior y exterior que dan nueva vida a su propiedad.",
      "service.painting.feature1": "Pintura interior",
      "service.painting.feature2": "Pintura exterior",
      "service.painting.feature3": "Consulta de color",
      "service.painting.feature4": "Acabados premium",
      
      "service.plumbing.title": "Fontanería",
      "service.plumbing.desc": "Servicios expertos de fontanería para instalaciones, reparaciones y mantenimiento. Rápido y confiable.",
      "service.plumbing.feature1": "Reparaciones de emergencia",
      "service.plumbing.feature2": "Instalación de tuberías",
      "service.plumbing.feature3": "Detección de fugas",
      "service.plumbing.feature4": "Reemplazo de accesorios",
      
      "service.plastering.title": "Enlucido",
      "service.plastering.desc": "Enlucido de alta calidad para paredes y techos suaves y perfectos. Acabado profesional garantizado.",
      "service.plastering.feature1": "Enlucido de paredes",
      "service.plastering.feature2": "Trabajo de techo",
      "service.plastering.feature3": "Trabajo de reparación",
      "service.plastering.feature4": "Acabados lisos",
      
      // How It Works
      "process.title": "Cómo Funciona",
      "process.subtitle": "Nuestro sencillo proceso de 4 pasos para transformar su espacio",
      "process.step1.number": "01",
      "process.step1.title": "Contáctenos",
      "process.step1.desc": "Comuníquese con nosotros por teléfono, correo electrónico o WhatsApp. Estamos listos para escuchar sobre su proyecto.",
      "process.step2.number": "02",
      "process.step2.title": "Reciba Su Presupuesto",
      "process.step2.desc": "Basándonos en su información, creamos un plan y presupuesto detallados. Lo recibirá dentro de 12 horas el mismo día.",
      "process.step3.number": "03",
      "process.step3.title": "Damos Vida a Su Visión",
      "process.step3.desc": "Nuestros profesionales experimentados ejecutan su proyecto con precisión. Relájese mientras nos encargamos de todo.",
      "process.step4.number": "04",
      "process.step4.title": "Acabado Perfecto",
      "process.step4.desc": "Añadimos los toques finales, aseguramos la perfección y superamos sus expectativas.",

      // Why Choose Us
      "why.title": "¿Por Qué Elegir Basic Job?",
      "why.subtitle": "El socio de confianza de Ámsterdam para renovación y mejoras del hogar",
      "why.quality": "Calidad Garantizada",
      "why.qualityDesc": "Respaldamos nuestro trabajo con garantías completas y aseguramiento de calidad.",
      "why.experience": "15+ Años de Experiencia",
      "why.experienceDesc": "Experiencia comprobada en todos los aspectos de renovación y mejoras del hogar.",
      "why.team": "Equipo Profesional",
      "why.teamDesc": "Artesanos capacitados que tratan su hogar con respeto y cuidado.",
      "why.ontime": "Entrega a Tiempo",
      "why.ontimeDesc": "Respetamos su tiempo y completamos proyectos dentro de los plazos acordados.",
      
      // Appointments
      "appointments.title": "Reservar una Cita",
      "appointments.subtitle": "Programe una consulta o visita al sitio a su conveniencia",
      "appointments.selectDate": "Seleccionar Fecha y Hora",
      "appointments.availableSlots": "Horarios Disponibles",
      "appointments.loading": "Cargando horarios...",
      "appointments.noSlots": "No hay horarios disponibles para esta fecha",
      "appointments.selected": "Seleccionado:",
      "appointments.details": "Sus Datos",
      "appointments.name": "Nombre Completo",
      "appointments.email": "Correo Electrónico",
      "appointments.phone": "Teléfono",
      "appointments.service": "Servicio",
      "appointments.address": "Dirección",
      "appointments.notes": "Notas Adicionales",
      "appointments.booking": "Reservando...",
      "appointments.book": "Reservar Cita",
      
      // Projects
      "projects.title": "Nuestros Proyectos Recientes",
      "projects.subtitle": "Vea la calidad de nuestro trabajo e inspírese para su próximo proyecto",
      "projects.all": "Todos",
      
      // Testimonials
      "testimonials.title": "Lo Que Dicen Nuestros Clientes",
      "testimonials.subtitle": "No se fíe solo de nuestra palabra - escuche a nuestros clientes satisfechos",
      "testimonials.googleButton": "Leer Más Reseñas en Google",
      
      // Testimonial Items
      "testimonial.1.name": "Garima Cupta",
      "testimonial.1.text": "¡Basic Job transformó completamente nuestro baño! El equipo fue profesional, limpio y terminó a tiempo. ¡Muy recomendado!",
      "testimonial.1.service": "Renovación de Baño",
      
      "testimonial.2.name": "Puneet Kedia",
      "testimonial.2.text": "El equipo de Basic Job recientemente hizo renovaciones en nuestra casa y la calidad del trabajo fue muy buena. Estamos muy satisfechos con su experiencia y atención al detalle.",
      "testimonial.2.service": "Renovación de Ático",
      "testimonial.2.location": "Utrecht",
      
      "testimonial.3.name": "Niharika Sinha",
      "testimonial.3.text": "Servicio de fontanería rápido, confiable y asequible. Arreglaron nuestro problema rápidamente y explicaron todo claramente. ¡Definitivamente los usaré de nuevo!",
      "testimonial.3.service": "Fontanería",
      "testimonial.3.location": "Uithoorn",
      
      "testimonial.4.name": "Tom Boudewijn",
      "testimonial.4.text": "El trabajo de pintura en nuestro apartamento fue impecable. Trabajo limpio, equipo profesional y la consulta de color fue realmente útil!",
      "testimonial.4.service": "Pintura",
      
      // Quote
      "quote.title": "Obtenga Su Presupuesto Gratis",
      "quote.subtitle": "Cuéntenos sobre su proyecto y nos pondremos en contacto dentro de 24 horas",
      "quote.message": "Detalles del Proyecto",
      "quote.sending": "Enviando...",
      "quote.send": "Solicitar Presupuesto Gratis",
      
      // Reschedule
      "reschedule.title": "Reprogramar Cita",
      "reschedule.subtitle": "Ingrese su ID de cita para reprogramar o cancelar",
      "reschedule.appointmentId": "ID de Cita",
      "reschedule.search": "Buscar",
      "reschedule.searching": "Buscando...",
      "reschedule.current": "Detalles de la Cita Actual",
      "reschedule.customerName": "Nombre del Cliente",
      "reschedule.currentDate": "Fecha Actual",
      "reschedule.currentTime": "Hora Actual",
      "reschedule.status": "Estado",
      "reschedule.newDateTime": "Seleccionar Nueva Fecha y Hora",
      "reschedule.actions": "Acciones",
      "reschedule.newAppointment": "Nueva cita:",
      "reschedule.confirm": "Confirmar Reprogramación",
      "reschedule.rescheduling": "Reprogramando...",
      "reschedule.cancel": "Cancelar Cita",
      "reschedule.help": "¿Necesita ayuda? Llámenos al",
      "reschedule.helpText": "Su ID de cita fue enviado a su correo electrónico cuando reservó. ¿No lo encuentra? Contáctenos en",
      
      // Footer
      "footer.about": "Su socio de confianza para servicios profesionales de renovación y mejoras del hogar en Ámsterdam.",
      "footer.quickLinks": "Enlaces Rápidos",
      "footer.ourServices": "Nuestros Servicios",
      "footer.contactUs": "Contáctenos",
      "footer.rights": "Todos los derechos reservados.",
      
      // Common
      "common.required": "*"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
